var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabletApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.75L7.5 36.25H32.5V3.75H7.5ZM5 36.25C5 37.6307 6.11929 38.75 7.5 38.75H32.5C33.8807 38.75 35 37.6307 35 36.25V3.75C35 2.36929 33.8807 1.25 32.5 1.25H7.5C6.11929 1.25 5 2.36929 5 3.75L5 36.25Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.859 16.9913C25.7908 17.0331 24.1671 17.9148 24.1671 19.8699C24.2436 22.0995 26.2162 22.8813 26.25 22.8813C26.2162 22.9232 25.9522 23.9465 25.1703 25.0192C24.5496 25.9433 23.8609 26.875 22.815 26.875C21.8201 26.875 21.4629 26.2592 20.315 26.2592C19.0821 26.2592 18.7333 26.875 17.7895 26.875C16.7436 26.875 16.0037 25.8934 15.3494 24.9781C14.4992 23.7799 13.7766 21.8998 13.7511 20.0945C13.7339 19.1379 13.9213 18.1975 14.3971 17.3988C15.0687 16.2837 16.2677 15.5267 17.5771 15.5018C18.5803 15.4687 19.4731 16.1758 20.0854 16.1758C20.6721 16.1758 21.7691 15.5018 23.0102 15.5018C23.5459 15.5024 24.9745 15.6603 25.859 16.9913ZM20.0005 15.3108C19.822 14.4372 20.315 13.5636 20.7742 13.0063C21.3609 12.3324 22.2876 11.875 23.0867 11.875C23.1378 12.7486 22.8145 13.6054 22.2366 14.2294C21.718 14.9033 20.8252 15.4107 20.0005 15.3108Z",
    fill: "#E1E1E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabletApple);
export default __webpack_public_path__ + "static/media/tablet_apple.70f4ab70efe2be7731b9ed089f1f7e40.svg";
export { ForwardRef as ReactComponent };